<template>
  <header>
    <h1 @click.prevent="$router.push('/')">Gusta Spanish Blog</h1>
    <nav>
      <div v-if="user">
        <router-link :to="{ name: 'Blog'}">Home</router-link>
        <router-link :to="{ name: 'Create'}" class="create">Create Post</router-link>
        <span>Hi {{ user.displayName }}</span>
        <i v-if="!url" class="fas fa-user-friends friends"></i>
        <img v-if="url" :src="url" alt="">
        <button class="logout" @click.prevent="handleOut">Log Out</button>
      </div>
      <div v-else>
        <router-link :to="{ name: 'Login'}">Log In</router-link>
        <router-link :to="{ name: 'Signup'}" class="create">Sign Up</router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import getUser from '../composables/getUser'
import useLogout from '../composables/useLogout'
import { useRouter } from 'vue-router'

export default {
  props: ['url'],
  setup(){
    const { user } = getUser();
    const { logout } = useLogout();
    const router = useRouter();
    const handleOut = async () => {
      await logout();
      router.push({ name: 'Login' });
    }
    return { user, handleOut };

  }
}
</script>

<style>
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px;
  }
  header h1 {
    color: #dfdfdf;
    font-size: 48px;
    cursor: pointer;
  }
  header span {
    padding-left: 10px;
  }
  header a {
    color: #bbb;
    text-decoration: none;
    margin-left: 10px;
  }
  header img {
    width: 32px;
    height: 32px;
    object-position: center center;
    object-fit: cover;
    border-radius: 50%;
    vertical-align: bottom;
    margin-left: 10px;
  }
  header i {
    margin-left: 10px;
  }
  header a:hover {
    color: #444;
  }
  header a.create {
    padding-left: 10px;
    border-left: 1px solid rgb(192, 192, 192);
  }
  header a.router-link-active {
    color: #444;
    font-weight: bold;
  }
  header button {
    display: inline-block;
    background: #ff8800;
    color: white;
    border: none;
    padding: 6px 14px;
    font-size: 16px;
    margin-left: 12px;
    cursor: pointer;
  }
  header button:hover {
    background: #c26802;
  }
</style>